<template>
  <div class="fill-height">
    <!--    <v-progress-linear :indeterminate="loginProgress" color="primary" :value="loginProgress ? 0 : 100">
        </v-progress-linear> -->
    <v-container class="fill-height pa-0" fluid>
      <v-row class="fill-height" align="center" justify="center">
        <v-card
          class="login-form"
          :outlined="!$vuetify.breakpoint.smAndDown"
        >
          <v-card-title class="justify-center">
            <h2 class="display-3 font-weight-medium">Sokol</h2>
          </v-card-title>
          <v-card-text class="inputs">
            <v-form v-on:submit.prevent="">
              <v-text-field :label="$t('component.login.username')"
                            :placeholder="$t('component.login.username')"
                            v-model="authData.username"
                            outlined
                            dense
                            name="username"
                            autocomplete="on" />

              <v-text-field :label="$t('component.login.password')"
                            :placeholder="$t('component.login.password')"
                            v-model="authData.password"
                            outlined
                            dense
                            type="password"
                            name="password"
                            class="mb-0"
                            autocomplete="on" />

              <v-checkbox
                v-model="authData.permanent"
                :label="$t('component.login.permanent')"
                dense
                class="mt-0 pt-0" />

              <v-select
                v-model="lang"
                :items="langs"
                item-text="code"
                :label="$t('view.company.country')"
                outlined
                dense
              >
                <template v-slot:selection="data">
                  <country-flag :country="data.item.flag" size="small" class="normal-flag-move" />
                  {{ data.item.name }}
                </template>
                <template v-slot:item="data">
                  <country-flag :country="data.item.flag" size="small" class="normal-flag-move" />
                  {{ data.item.name }}
                </template>
              </v-select>

              <v-btn @click="login" block color="primary" value="login" name="dologin" type="submit"
                     :disabled="loginProgress">{{ $t("component.login.confirm") }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { Settings } from "luxon";

export default {
  name: "LoginForm",

  data() {
    return {
      authData: {
        username: null,
        password: null,
        permanent: false
      },
      pwDialog: false,
      loginProgress: false,
      langs: [
        { code: "cs", flag: "cz", name: "čeština" },
        { code: "sk", flag: "sk", name: "slovenčina" }
      ],
      lang: this.getLanguage()
    };
  },

  methods: {
    login() {
      this.loginProgress = true;
      var tid;
      this.$store.dispatch("progress/add", "Login")
        .then(id => {
          tid = id;
        });

      this.$emit("login", this.authData, () => {
        this.loginProgress = false;
        this.authData.password = null;

        this.$store.dispatch("progress/remove", tid);
      });
    },

    getLanguage() {
      var lang = navigator.language || navigator.userLanguage;

      if (i18n.messages[lang] === undefined)
        lang = "sk";

      return lang;
    },

    changeLanguage(lang) {
      if (i18n.messages[lang] === undefined)
        lang = "sk";

      Settings.defaultLocale = lang;
      i18n.locale = lang;
    }
  },

  watch: {
    lang: function(newVal) {
      this.changeLanguage(newVal);
    }
  },

  mounted() {
    this.changeLanguage(this.getLanguage());
  }
};
</script>

<style scoped>
.login-form {
  width: 450px;
}

h2 {
  color: #c06432;
}

.inputs {
  padding-left: 80px;
  padding-right: 80px;
}

</style>
